import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=31fac81d&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=31fac81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fac81d",
  null
  
)

export default component.exports